import React from "react";

/**
 * Helper component that renders if no dishes have been ordered.
 */
const NoOrder: React.FC<{}> = () => (
  <p className="no-order text-center"> You haven't ordered anything yet. </p>
);

export default NoOrder;
